export default {
	select: {
		isOptionsVisible: 'is-options-visible',
	},
	// TODO replace with new accordion
	accordion: {
		toggleActive: 'faq__link--active',
		contentActive: 'faq__text--open',
		iconActive: 'faq__icon--active',
	},
	accordionNew: {
		active: 'active',
	},
	catalog: {
		filter: {
			isVisible: 'active',
		},
	},
	dNone: 'd-none',
	search: {
		active: 'active',
	},
};
